module.exports = __webpack_public_path__ + "img/gill4.fa2ca700.svg";